import React from 'react'

export const rateCallSvg = <svg className="iconBarCall" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
				viewBox="-3 -3 30 30" enableBackground="new 0 0 24 24" xmlSpace="preserve">
					<g>
						<polygon className="st0" points="8,20.6 2,14.6 4.1,12.5 8,16.4 19.9,4.5 22,6.6 				"/>
					</g>
				</svg>

export const dtmfSVG = <svg className="iconBarCall" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="-1 -3 26 26" enableBackground="new 0 0 24 24" xmlSpace="preserve">
			<g><circle className="st0" cx="6.2" cy="2.7" r="1.9"/></g>
			<g><circle className="st0" cx="12" cy="2.7" r="1.9"/></g>
			<g><circle className="st0" cx="17.8" cy="2.7" r="1.9"/></g>
			<g><circle className="st0" cx="6.2" cy="8.5" r="1.9"/></g>
			<g><circle className="st0" cx="12" cy="8.5" r="1.9"/></g>
			<g><circle className="st0" cx="17.8" cy="8.5" r="1.9"/></g>
			<g><circle className="st0" cx="6.2" cy="14.3" r="1.9"/></g>
			<g><circle className="st0" cx="12" cy="14.3" r="1.9"/></g>
			<g><circle className="st0" cx="17.8" cy="14.3" r="1.9"/></g>
			<g><circle className="st0" cx="12" cy="20.1" r="1.9"/></g>
			</svg>

export const volume = <svg version="1.1" id="Layer_1" className="iconBarCall" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
<path d="M6,11.921v6.158h3.999L15,23.21V6.79l-5.001,5.132H6z M19.5,15c0-1.816-1.02-3.376-2.5-4.135v8.26
	C18.48,18.377,19.5,16.816,19.5,15z M17,6v2.114c2.891,0.883,5,3.633,5,6.886c0,3.253-2.109,6.003-5,6.887V24
	c4.01-0.934,7-4.608,7-9S21.01,6.934,17,6z"/>
</svg>

export const volumeMedium = <svg version="1.1" id="Layer_1" className="iconBarCall" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="0 2 26 26" enableBackground="new 0 0 30 30" xmlSpace="preserve">
   <path d="M6,11.921v6.158h3.999L15,23.21V6.79l-5.001,5.132H6z M19.5,15c0-1.816-1.02-3.376-2.5-4.135v8.26
   	C18.48,18.377,19.5,16.816,19.5,15z"/>
</svg>

export const noVolume = <svg version="1.1" className="iconBarCall" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="0 0 30 30" enableBackground="new 0 0 30 30;" xmlSpace="preserve">
   <path className="st0" d="M19.5,15c0-1.8-1-3.3-2.5-4v2.2l2.4,2.4C19.5,15.4,19.5,15.2,19.5,15z M22,15c0,0.9-0.2,1.8-0.5,2.6l1.5,1.5
   	c0.7-1.2,1-2.7,1-4.2c0-4.3-3-7.9-7-8.8v2.1C19.9,9.1,22,11.8,22,15z M7.3,6L6,7.3l4.7,4.7H6v6h4l5,5v-6.7l4.2,4.2
   	c-0.7,0.5-1.4,0.9-2.2,1.2v2.1c1.4-0.3,2.6-0.9,3.7-1.8l2,2l1.3-1.3l-9-9L7.3,6z M15,7l-2.1,2.1l2.1,2.1V7z"/>
</svg>

export const mute = <svg version="1.1" className="iconBarCall" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="0 0 30 30" enableBackground="new 0 0 30 30;" xmlSpace="preserve">
<g id="Group_1341" transform="translate(6951 -27)">
	<g id="Group_1235">
		<g id="Group_1234">
			<path id="Path_639" d="M-6943.729,33.5l-1.271,1.27l6.01,6.01v0.72c-0.007,1.649,1.324,2.992,2.974,3
				c0.005,0,0.011,0,0.016,0c0.219-0.001,0.437-0.028,0.649-0.08l1.661,1.659c-0.724,0.34-1.512,0.518-2.311,0.521
				c-2.865,0.061-5.238-2.212-5.3-5.077c0-0.008,0-0.016,0-0.024h-1.7c0.095,3.403,2.63,6.242,6,6.72v3.28h1.999v-3.28
				c0.897-0.133,1.761-0.438,2.541-0.899l4.189,4.18l1.271-1.271L-6943.729,33.5z M-6933.021,41.67c0-0.06,0.021-0.11,0.021-0.17v-6
				c0-1.657-1.344-3-3-3c-1.657,0-3,1.343-3,3v0.18L-6933.021,41.67z M-6929,41.5h-1.7c0,0.706-0.146,1.404-0.43,2.05l1.229,1.23
				C-6929.318,43.784-6929.008,42.653-6929,41.5"/>
		</g>
	</g>
</g>
</svg>

export const hold = <svg version="1.1" className="iconBarCall" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="0 0 30 30" enableBackground="new 0 0 30 30;" xmlSpace="preserve">
<g id="Group_1346" transform="translate(7014 -27)">
	<path id="Path_544" d="M-6996.334,51h5.334V33h-5.334V51z M-7007,51h5.332V33H-7007V51z"/>
</g>
</svg>

export const resume = <svg version="1.1" className="iconBarCall" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="2 2 26 26" enableBackground="new 0 0 30 30;" xmlSpace="preserve">
<g id="Group_1367" transform="translate(3642 -1424.15)">
	<path id="Path_634" d="M-3622.896,1438.745l-4.038,4.982l-4.038-4.982v-7.595h8.076V1438.745z"/>
	<rect id="Rectangle_258" x="-3634" y="1445.147" width="14" height="2.003"/>
</g>
</svg>

export const ivr = <svg version="1.1" className="iconBarCall" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="2 3 26 26" enableBackground="new 0 0 30 30;" xmlSpace="preserve">
<g id="Group_1355" transform="translate(7131 -23)">
	<g id="Group_1252">
		<g id="Group_1247" transform="translate(0 9.5)">
			<path id="Path_643" d="M-7120.071,35.06c-0.001,0.249-0.203,0.451-0.452,0.451h-4.524
				c-0.249,0-0.451-0.201-0.453-0.451V31.44c0.001-0.249,0.203-0.45,0.452-0.452h4.525c0.249,0.002,0.45,0.203,0.451,0.452
				L-7120.071,35.06z"/>
		</g>
		<g id="Group_1248" transform="translate(6.786 9.5)">
			<path id="Path_644" d="M-7120.071,35.06c-0.001,0.249-0.202,0.451-0.452,0.451h-4.524
				c-0.249,0-0.452-0.201-0.453-0.451V31.44c0.001-0.249,0.203-0.45,0.452-0.452h4.525c0.248,0.002,0.45,0.203,0.451,0.452
				L-7120.071,35.06z"/>
		</g>
		<g id="Group_1249" transform="translate(13.571 9.5)">
			<path id="Path_645" d="M-7120.071,35.06c-0.001,0.249-0.203,0.451-0.452,0.451h-4.524
				c-0.249,0-0.451-0.201-0.452-0.451V31.44c0.001-0.249,0.202-0.45,0.451-0.452h4.524c0.249,0.002,0.45,0.203,0.452,0.452
				L-7120.071,35.06z"/>
		</g>
		<g id="Group_1250" transform="translate(2.262 4.071)">
			<path id="Path_646" d="M-7125.5,30.989v4.071c-0.023,0.248,0.159,0.469,0.407,0.492
				s0.469-0.159,0.492-0.407c0.003-0.028,0.003-0.057,0-0.085v-3.171h12.671v3.171c-0.023,0.248,0.158,0.469,0.407,0.492
				s0.47-0.159,0.493-0.407c0.002-0.028,0.002-0.057,0-0.085v-4.071H-7125.5z"/>
		</g>
		<g id="Group_1251" transform="translate(9.048)">
			<path id="Path_647" d="M-7125.5,30.988v8.144c-0.023,0.249,0.159,0.469,0.408,0.492
				s0.469-0.159,0.492-0.407c0.002-0.028,0.002-0.057,0-0.085v-8.144H-7125.5z"/>
		</g>
	</g>
</g>
</svg>

export const record = <svg version="1.1" className="iconBarCall" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="2 2 26 26" enableBackground="new 0 0 30 30;" xmlSpace="preserve">
<g id="Group_1359" transform="translate(7181 -20)">
	<g id="Group_1293">
		<g id="Group_1292" transform="translate(0 0)">
			<path id="Path_665" d="M-7160.312,38.004c-1.673,0.014-3.042-1.328-3.063-3
				c0.018-1.676,1.388-3.021,3.062-3.007c1.676-0.014,3.046,1.332,3.063,3.007C-7157.271,36.676-7158.64,38.017-7160.312,38.004
				 M-7171.688,38.004c-1.672,0.014-3.042-1.328-3.062-3c0.017-1.675,1.386-3.021,3.062-3.007c1.675-0.014,3.046,1.332,3.063,3.007
				C-7168.646,36.676-7170.015,38.017-7171.688,38.004 M-7160.312,30.271c-2.632-0.025-4.787,2.088-4.812,4.721
				c0,0.003,0,0.007,0,0.011c0,1.099,0.391,2.162,1.104,3h-3.956c0.711-0.838,1.102-1.901,1.102-3
				c-0.023-2.633-2.177-4.749-4.809-4.725c-0.001,0-0.003,0-0.004,0c-2.633-0.025-4.788,2.089-4.812,4.722c0,0.001,0,0.002,0,0.003
				c0.023,2.632,2.176,4.748,4.809,4.725c0.001,0,0.002,0,0.004,0h11.375c2.633,0.025,4.787-2.089,4.812-4.721
				c0-0.001,0-0.002,0-0.003c-0.023-2.633-2.177-4.749-4.809-4.725c-0.001,0-0.003,0-0.004,0"/>
		</g>
	</g>
</g>
</svg>

export const hangUp = <svg version="1.1" className="iconBarHangUp" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="0 0 30 30" enableBackground="new 0 0 30 30;" xmlSpace="preserve">
<g id="Group_1556" transform="translate(7231 -22)">
	<g id="Group_1054">
		<g id="Group_1053">
			<path id="Path_549" d="M-7216,34.57c-1.562-0.002-3.114,0.241-4.6,0.72v3.1c0,0.382-0.217,0.73-0.56,0.9
				c-0.969,0.487-1.865,1.11-2.66,1.85c-0.186,0.183-0.438,0.283-0.7,0.279c-0.266,0.002-0.521-0.102-0.709-0.289l-2.48-2.48
				c-0.189-0.184-0.294-0.437-0.29-0.7c-0.002-0.266,0.103-0.521,0.29-0.709c3.159-3.003,7.352-4.675,11.71-4.67
				c4.357-0.004,8.552,1.667,11.71,4.67c0.387,0.394,0.387,1.025,0,1.419l-2.48,2.48c-0.189,0.187-0.443,0.291-0.709,0.289
				c-0.262-0.001-0.512-0.101-0.7-0.279c-0.797-0.742-1.695-1.365-2.67-1.851c-0.344-0.168-0.562-0.517-0.561-0.899v-3.1
				C-7212.891,34.812-7214.44,34.565-7216,34.57"/>
		</g>
	</g>
</g>
</svg>

export const hangUpLeaveMessage = <svg className="iconBarCall" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
width="26.5px"viewBox="0 0 22 22" enableBackground="new 0 0 22 22" xmlSpace="preserve">
<path d="M11,2.5c-5.5,0-10,3.6-10,8c0,1.8,0.8,3.5,2,4.8l-1,4.2l4.1-2c1.5,0.7,3.1,1,4.9,1c5.5,0,10-3.6,10-8
C21,6.1,16.5,2.5,11,2.5z M16.3,13.8l-2.7-2V9.6c-0.8-0.3-1.7-0.5-2.7-0.5c-0.9,0-1.8,0.2-2.7,0.5v2.2l-2.7,2L3,11.2
c1.3-1.7,3.2-3,5.3-3.6c0.9-0.2,1.7-0.4,2.7-0.4s1.8,0.1,2.7,0.4c2.2,0.6,4,1.9,5.3,3.6L16.3,13.8z"/>
</svg>

export const moreOptions = <svg version="1.1" className="iconBarCall" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
<g id="Group_2372" transform="translate(2463 -315)">
	<circle id="Ellipse_15" cx="-2455" cy="330" r="2.5"/>
	<circle id="Ellipse_16" cx="-2448" cy="330" r="2.5"/>
	<circle id="Ellipse_17" cx="-2441" cy="330" r="2.5"/>
</g>
</svg>

export const assistedTransfer = <svg className="iconBarCall" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="-3 -3 30 30" enableBackground="new 0 0 24 24;" xmlSpace="preserve">
   <g id="Group_1128_1_">
	   <g id="Path_587_1_">
		   <path className="st0" d="M2.1,15.5v3.5c0,0.5,0.4,1,1,1c9.3,0,16.9-7.5,16.9-16.9v0c0-0.5-0.4-1-1-1h-3.5c-0.5,0-1,0.4-1,1
			   c0,1.2-0.2,2.4-0.6,3.5c-0.1,0.4,0,0.7,0.2,1l2.2,2.2c-1.4,2.8-3.7,5.1-6.5,6.5l-2.2-2.2c-0.3-0.3-0.7-0.3-1-0.2
			   c-1.1,0.4-2.3,0.6-3.5,0.6C2.5,14.5,2.1,14.9,2.1,15.5"/>
	   </g>
   </g>
	   <g id="Group_1129_2_" transform="translate(1.763 0.735)">
		   <g id="Path_588_2_">
			   <g>
				   <polygon className="st0" points="3.8,5.1 2.3,3.7 2.3,8.8 7.4,8.8 5.9,7.3 						"/>
			   </g>
		   </g>
	   </g>
		   <g>
				   <rect x="4.8" y="4.7" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.0367 7.1378)" className="st0" width="5.6" height="2.6"/>
		   </g>
	   <g id="Group_1129_1_" transform="translate(1.763 0.735)">
		   <g id="Path_588_1_">
			   <g>
				   <polygon className="st0" points="18.7,18.4 20.1,19.8 20.1,14.7 15.1,14.7 16.6,16.3 						"/>
			   </g>
		   </g>
	   </g>
		   <g>
			   <rect x="15.6" y="17.7" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -8.0253 18.5622)" className="st0" width="5.6" height="2.6"/>
		   </g>
</svg>


// WEBPACK FOOTER //
// ./src/Images/CallSpaceHeaderSVG.js